module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_25",
      "title": "25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVIDENCE LAB, FBI HEADQUARTERS, QUANTICO, VA")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Still stuck in the Evidence Analysis Lab, Ezra swigged acrid coffee and flipped through the crime scene photos on the computer. Over a hundred images of the cage, the barren basement, the dead girl. He glanced up at the clock. Almost 4:00 "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("A.M.")]), _vm._v(" and he still had to write everything up before 6:00. He clacked his tongue stud along his teeth to keep himself awake as he stared at the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("On autopilot, his brain took a second to register something strange. Shaking his head, he went back to the previous image and squinted, trying to figure out what he was seeing. The cage took up half the frame, but along the wall behind it, a flare shone from the grout between two bricks. Ezra enlarged the image. Sure enough, something was reflecting the flash, creating a glint of light.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Hey, Cindy, come here and look at this,” Ezra called loud enough for the techs in the next room to hear him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Cindy peeked around the corner. “What’s up?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Come look at this photo. I think the flash might be reflecting off something in the wall.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_26",
      "title": "26"
    }
  }, [_vm._v("She bent over him at the table to take a closer look, and Ezra thought about last night. They had just started sleeping together, and he wondered if it might be something more than sex. She smelled of stale coffee and chemicals, which made him smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He reached up and tucked a strand of thin blond hair behind her ear. She swatted him away. “Not at work!” She focused on the photo. “I think you’re right. Let’s go check it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, we’re going to have to go back today anyway. Let’s go now so we can write it up before the task force meeting. It could be important.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("After leaving a quick message on Sayer’s voice mail, the evidence techs drove the van back up to D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The residential street was deep in slumber when they arrived. The barest hint of sunrise glowed on the horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A single D.C. police officer sat outside in his car keeping an eye on the scene. He recognized them and gave a nod as they made their way into the town house.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ezra pulled aside the door propped against the entry. A rat scurried across the floor. The smell of death lingered in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("With a flashlight they descended the creaking stairs and clicked on the floodlights still in the basement. Ezra held up the printed image so they could figure out exactly where it was taken. They circled the room until the image lined up. Cindy hurried to the wall and found a small hole.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“There really is something here,” she whispered, even though they were alone.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What do you think? A camera lens or something? But where would it lead?” Ezra looked around. “I looked at the floor plans and there’s no basement next door, so where would the camera be? Maybe it’s wireless, but there would have to be some kind of receiver nearby.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“A false wall? Or maybe an entry somewhere else in the house?” "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_27",
      "title": "27"
    }
  }, [_vm._v("Cindy’s voice cracked with excitement. This was every evidence tech’s dream, the big find everyone else missed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("They circled the room in opposite directions.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Cindy walked over and squatted next to a plywood wall that covered the back of the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Hey, check this out.” She slid her fingers along a seam between two boards.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ezra looked up just as she pushed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, don’t!” he shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The panel swung inward.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ezra held his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He let out a puff of air. “God, Cindy, didn’t you see that the guy rigged a shotgun on the stairs? Be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, sorry.” Cindy didn’t look sorry at all. Her eyes glowed with the thrill of discovery. “Come check this out.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ezra squeezed next to her and looked into the crawl space underneath the stairs. Just inside, a metal hatch sat in the concrete floor.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("They stared for a moment, contemplating their next move.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We’ve got to call Holt and Sayer,” Ezra said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("As he pulled out his phone, three staccato clangs echoed up from the hatch, then three slow clangs, and three fast again. Over and over.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What is that?” Cindy cocked her head.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Someone down there hitting a metal pipe or something? Too regular to be old pipes.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("They listened, ears buzzing, and it struck Ezra like lightning. “That’s SOS in Morse code!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, SOS, someone’s down there calling for help!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Cindy stepped forward into the crawl space and thumped her foot hard on the hatch. The reverberation sounded like a huge drum being struck.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_28",
      "title": "28"
    }
  }, [_vm._v("A faint young girl’s voice echoed up from the floor. “Is someone there? Please help me!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Cindy looked up, wide-eyed. “You call it in while I go down.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Before he could even shout for her to stop, Cindy yanked open the hatch.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The world exploded.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed362e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 84
// module chunks = 0